export default __webpack_public_path__ + "static/media/eb-pro-wht-3.3189f5ea.png";